import { render, staticRenderFns } from "./TwoColumnsPopUp.vue?vue&type=template&id=508c1260&scoped=true&"
import script from "./TwoColumnsPopUp.vue?vue&type=script&lang=js&"
export * from "./TwoColumnsPopUp.vue?vue&type=script&lang=js&"
import style0 from "./TwoColumnsPopUp.vue?vue&type=style&index=0&id=508c1260&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508c1260",
  null
  
)

export default component.exports